<div class="item-grabber">
  <rt-icon name="drag-vertical"></rt-icon>
</div>

<div class="item-content">
  <div *ngIf="!titleEditorOpen" class="item-title-actions">
    <div class="item-title">
      {{ title }}
    </div>
    <div *ngIf="editable" class="item-actions">
      <rt-group>
        <rt-button *ngIf="renamable" (click)="onEditItemClick()" variant="small plain only-icon">
          <rt-icon name="edit"></rt-icon>
        </rt-button>
        <rt-button
          *ngIf="removable"
          [loading]="processing"
          (click)="onDeleteItemClick()"
          variant="small plain only-icon danger-on-hover"
        >
          <rt-icon name="delete"></rt-icon>
        </rt-button>
      </rt-group>
    </div>
  </div>
  <rt-list-sortable-form
    *ngIf="titleEditorOpen"
    [value]="title"
    (cancelClick)="onCancelClick()"
    (saveClick)="onEditName($event)"
  >
  </rt-list-sortable-form>
</div>
